@if (isLoading()) {
  <app-loader/>
}
<div class="wrapper">
  <app-page-info
    [resourceName]="dailyFeedbackReportsResourceType.name"
    [loginAndRoles]="loginAndRoles()"
  />
  <app-daily-feedback-reports-filters
    (handleGetData)="selectDate($event)"
    (updateGroupStyles)="updateGroupStyles($event)"
  />
  @if (dailyFeedbackReportsDataService.dailyFeedbackReportsData().length) {
    <app-daily-feedback-reports-page-content
      [groupStyles]="groupStyles()"
    />
    <app-daily-feedback-reports-page-pagination
      [dailyFeedbackReportsPaginationData]="dailyFeedbackReportsPaginationDataService.dailyFeedbackReportsPaginationData()"
      (selectedPage)="selectedPage()"
    />
  } @else {
    <div class="empty">
      <h3>Нет данных за выбранный период!</h3>
      <div>Выберите другой период</div>
    </div>
  }
</div>
